/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateRecommendedPublisherDto
 */
export interface CreateUpdateRecommendedPublisherDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRecommendedPublisherDto
     */
    profileId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateRecommendedPublisherDto
     */
    clientIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRecommendedPublisherDto
     */
    scopeType: CreateUpdateRecommendedPublisherDtoScopeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRecommendedPublisherDto
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRecommendedPublisherDto
     */
    purchaserId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateRecommendedPublisherDto
     */
    active?: boolean;
}


/**
 * @export
 */
export const CreateUpdateRecommendedPublisherDtoScopeTypeEnum = {
    Global: 'Global',
    Company: 'Company',
    Purchaser: 'Purchaser'
} as const;
export type CreateUpdateRecommendedPublisherDtoScopeTypeEnum = typeof CreateUpdateRecommendedPublisherDtoScopeTypeEnum[keyof typeof CreateUpdateRecommendedPublisherDtoScopeTypeEnum];


/**
 * Check if a given object implements the CreateUpdateRecommendedPublisherDto interface.
 */
export function instanceOfCreateUpdateRecommendedPublisherDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "profileId" in value;
    isInstance = isInstance && "clientIds" in value;
    isInstance = isInstance && "scopeType" in value;

    return isInstance;
}

export function CreateUpdateRecommendedPublisherDtoFromJSON(json: any): CreateUpdateRecommendedPublisherDto {
    return CreateUpdateRecommendedPublisherDtoFromJSONTyped(json, false);
}

export function CreateUpdateRecommendedPublisherDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateRecommendedPublisherDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'clientIds': json['clientIds'],
        'scopeType': json['scopeType'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'purchaserId': !exists(json, 'purchaserId') ? undefined : json['purchaserId'],
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function CreateUpdateRecommendedPublisherDtoToJSON(value?: CreateUpdateRecommendedPublisherDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profileId': value.profileId,
        'clientIds': value.clientIds,
        'scopeType': value.scopeType,
        'companyId': value.companyId,
        'purchaserId': value.purchaserId,
        'active': value.active,
    };
}

